import { AnimatePresence, motion } from 'framer-motion';
import { FC } from 'react';
import { Box } from 'styled-system/jsx';
import { WalletLayoutPropTypes } from '../../types/Wallet.types';

const WalletLayout: FC<WalletLayoutPropTypes> = ({ children }) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Box
          width="100%"
          paddingBottom={24}
          maxWidth="maxContainer"
          margin="auto"
        >
          {children}
        </Box>
      </motion.div>
    </AnimatePresence>
  );
};

export default WalletLayout;
